import {BaseModel} from "../../../infrastructure/models/base-model";
import type {NewsDomainModel} from "../../../domain/news/models/news.domain-model";

export class NewsWidgetItemMetaData extends BaseModel {
  item: NewsDomainModel;
  position: Number;

  constructor(position: number, item: NewsDomainModel) {
    super();

    this.position = position;
    this.item = item;
  }

  get publishDate(): String {
    return this.item.publishDate;
  }

  get itemImageSrc(): String {
    return this.item.image.url;
  }

  get itemAuthor(): String {
    return this.item.source.name;
  }

  get itemHeadline(): String {
    return this.item.title;
  }

  get itemUrl(): String {
    return this.item.url;
  }
}
